export const prepareFieldColture = (updatePayload, fieldToUpdate) => {
  let updatedFieldColture =
    fieldToUpdate?.field_colture?.map((culture) => ({
      colture: culture.colture.id || culture.colture,
      start_date: culture.start_date,
      end_date: culture.end_date,
      ...(culture.id && { id: culture.id }),
    })) || [];

  if (updatePayload?.genericInfo?.field_colture) {
    const newColture = {
      colture: updatePayload.genericInfo.field_colture,
      start_date: updatePayload.genericInfo.start_date,
      end_date: updatePayload.genericInfo.end_date,
    };

    if (updatedFieldColture.length > 0) {
      updatedFieldColture[updatedFieldColture.length - 1] = newColture;
    } else {
      updatedFieldColture.push(newColture);
    }
  }

  return updatedFieldColture;
};

const getCurrentCulture = (fieldToUpdate) => {
  return fieldToUpdate?.field_colture?.length > 0
    ? fieldToUpdate.field_colture[fieldToUpdate.field_colture.length - 1]
    : null;
};

const checkCultureAlreadyIncluded = (cultureArray, culture) => {
  return cultureArray.some(
    (item) =>
      item.colture === (culture.colture.id || culture.colture) &&
      item.start_date === culture.start_date &&
      item.end_date === culture.end_date
  );
};

const formatFieldParts = (fieldParts) => {
  return fieldParts?.map((part) => {
    if (part.name && part.field_type) {
      return {
        name: part.name,
        field_type: part.field_type?.id || part.field_type,
        organic_soil_percentage: part.organic_soil_percentage || 0,
        stone_percentage: part.stone_percentage || 0,
        polygon: part.polygon || [],
        ...(part.id && { id: part.id }),
      };
    } else {
      return {
        name: part.subAreaName,
        field_type: part.subAreaType,
        organic_soil_percentage: part.organicSubstance || 0,
        stone_percentage: part.stoneDensity || 0,
        polygon: part.subPolygonCoordinates || [],
        ...(part.id && { id: part.id }),
      };
    }
  });
};

export const formatGenericInfo = (updatePayload, fieldToUpdate) => {
  const updatedFieldColture = prepareFieldColture(updatePayload, fieldToUpdate);
  return {
    name: updatePayload?.genericInfo?.name,
    field_type: updatePayload?.genericInfo?.field_type,
    irrigation_system: updatePayload?.genericInfo?.irrigation_system,
    organic_soil_percentage: 0,
    stone_percentage: 0,
    field_colture: updatedFieldColture,
    field_parts: formatFieldParts(fieldToUpdate.field_parts),
    polygon: fieldToUpdate.polygon,
    has_sub_field: updatePayload.genericInfo.has_sub_field,
  };
};

export const formatCropHistory = (updatePayload, fieldToUpdate) => {
  const updatedFieldColture = updatePayload.cropHistory.map((culture) => ({
    colture: culture.colture.id || culture.colture,
    start_date: culture.start_date,
    end_date: culture.end_date,
    ...(culture.id && { id: culture.id }),
  }));

  const currentCulture = getCurrentCulture(fieldToUpdate);
  if (currentCulture) {
    const isCurrentCultureAlreadyIncluded = checkCultureAlreadyIncluded(
      updatedFieldColture,
      currentCulture
    );

    if (!isCurrentCultureAlreadyIncluded) {
      updatedFieldColture.push({
        colture: currentCulture.colture.id || currentCulture.colture,
        start_date: currentCulture.start_date,
        end_date: currentCulture.end_date,
        ...(currentCulture.id && { id: currentCulture.id }),
      });
    }
  }

  return {
    name: fieldToUpdate?.name,
    field_type: fieldToUpdate?.field_type?.id,
    irrigation_system: fieldToUpdate?.irrigation_system?.id,
    organic_soil_percentage: 0,
    stone_percentage: 0,
    field_colture: updatedFieldColture,
    field_parts: formatFieldParts(fieldToUpdate.field_parts),
    polygon: fieldToUpdate.polygon,
    has_sub_field: fieldToUpdate?.has_sub_field,
  };
};

export const formatFieldMap = (
  updatePayload,
  fieldToUpdate,
  hasPolygonChanged
) => {
  const updatedPolygon = updatePayload?.fieldMap?.polygonCoordinates;
  const hasUpdatedPolygon = Array.isArray(updatedPolygon);
  const hasDeletedPolygon =
    hasPolygonChanged && hasUpdatedPolygon && updatedPolygon.length === 0;
  const formattedFieldColture = fieldToUpdate?.field_colture?.map(
    (culture) => ({
      colture: culture.colture.id,
      start_date: culture.start_date,
      end_date: culture.end_date,
      ...(culture.id && { id: culture.id }),
    })
  );

  const basePayload = {
    name: fieldToUpdate?.name,
    field_type: fieldToUpdate?.field_type?.id,
    irrigation_system: fieldToUpdate?.irrigation_system?.id,
    organic_soil_percentage: 0,
    stone_percentage: 0,
    field_colture: formattedFieldColture,
  };

  if (hasDeletedPolygon) {
    return {
      ...basePayload,
      has_sub_field: fieldToUpdate?.has_sub_field,
    };
  }

  return {
    ...basePayload,
    field_parts: hasPolygonChanged
      ? []
      : formatFieldParts(fieldToUpdate.field_parts),
    polygon:
      hasPolygonChanged && hasUpdatedPolygon && updatedPolygon.length > 0
        ? updatedPolygon
        : fieldToUpdate.polygon,
    has_sub_field: fieldToUpdate?.has_sub_field,
  };
};

export const formatSubAreas = (updatePayload, fieldToUpdate) => {
  const formattedFieldColture = fieldToUpdate?.field_colture?.map(
    (culture) => ({
      colture: culture.colture.id,
      start_date: culture.start_date,
      end_date: culture.end_date,
      ...(culture.id && { id: culture.id }),
    })
  );

  return {
    name: fieldToUpdate?.name,
    field_type: fieldToUpdate?.field_type?.id,
    irrigation_system: fieldToUpdate?.irrigation_system?.id,
    organic_soil_percentage: 0,
    stone_percentage: 0,
    field_colture: formattedFieldColture,
    field_parts: formatFieldParts(updatePayload?.subAreas),
    polygon: fieldToUpdate.polygon,
    has_sub_field: fieldToUpdate?.has_sub_field,
  };
};
